export const vacancyRepository = {
  async search(filters = {}) {
    try {
      const { $apiMethods, $helpers } = useNuxtApp()
      const label = $helpers.getLabelId()

      const params = new URLSearchParams(filters).toString()
      const url = `${$apiMethods.getApiHostUrl()}/api/${label}/vacancies/search${params ? `?${params}` : ''}`

      const result = await $apiMethods.loadJSONApi(url)

      return result
    } catch (error) {
      console.error('Failed to search vacancies:', error)
      throw error
    }
  },

  async getBySlug(slug) {
    try {
      const { $apiMethods, $helpers } = useNuxtApp()
      const dataAll = useDataAll()
      const label = $helpers.getLabelId()
      const language = dataAll.getLanguage()

      const url = `${$apiMethods.getApiHostUrl()}/api/${label}/vacancies/${language}/${slug}`

      return await $apiMethods.loadJSONApi(url)
    } catch (error) {
      console.error('Failed to search vacancies:', error)
      throw error
    }
  },

  async submitApplication(vacancyId, formData) {
    try {
      const { $apiMethods, $helpers } = useNuxtApp()
      const label = $helpers.getLabelId()

      const url = `${$apiMethods.getApiHostUrl()}/api/${label}/vacancies/${vacancyId}/apply`

      return await $fetch(url, {
        method: 'POST',
        body: formData
      })
    } catch (error) {
      console.error('Failed to submit Application:', error)
      throw error;
    }
  },

  async submitOpenApplication(vacancyId, formData) {
    // Open applications now use the regular submitApplication flow
    // with the "open-sollicitatie" vacancy fetched by slug.
    return this.submitApplication(vacancyId, formData)
  }
}
